module.exports = __webpack_public_path__ + "static/media/email.a8a53dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/email.png
// module id = ./src/assets/email.png
// module chunks = 0